import DOMPurify from 'dompurify';

export const sanitizeHtml = (errorMessage: string): string =>
	DOMPurify.sanitize(errorMessage, {
		ALLOWED_TAGS: ['p', 'a', 'ol', 'ul', 'li'],
		ALLOWED_ATTR: ['href', 'target'],
	});
